// The raw brand palette — the TS source of truth. `packages/ui/styles/_tokens.scss`
// declares the same entries under the same names (`void` here is `$void` there,
// `inkLight2` is `$ink-light-2`), and `mirror.test.ts` fails when either half is
// edited alone. Roles (what plays bg-base, text-muted, accent…) live in
// `semantic.ts`; this file only names colours.
//
// Every value is an exact CSS colour string: `#rrggbb` when opaque, `rgba(…)`
// when it carries alpha. Ink hierarchy is OPACITY of one hue, never a second
// hue. Contrast ratios (WCAG AA 4.5:1 for every text colour on its theme's three
// surfaces; the `4` tier is faint and never carries text) are commented beside
// each entry in `_tokens.scss` and computed by `contrast.test.ts`.

export const PALETTE = {
  white: '#ffffff',

  // Dark (brand)
  void: '#050608',
  panel: '#0a0c10',
  panelRaised: '#0e1116',
  ink: '#f2f4f7',
  ink2: 'rgba(242, 244, 247, 0.62)',
  ink3: 'rgba(242, 244, 247, 0.55)',
  ink4: 'rgba(242, 244, 247, 0.28)',
  hairlineRule: 'rgba(255, 255, 255, 0.07)',
  hairlinePanel: 'rgba(255, 255, 255, 0.09)',
  working: '#8e99ff',
  workingDeep: '#4f5bd5',
  link: '#b9c0ff',
  linkHover: '#ffffff',
  shipped: '#7fe0b0',
  danger: '#f2555a',
  warning: '#e8a33d',

  // Light (derived)
  paper: '#f7f8fa',
  paperPanel: '#ffffff',
  paperRaised: '#eef0f4',
  inkLight: '#0a0c10',
  inkLight2: 'rgba(10, 12, 16, 0.7)',
  inkLight3: 'rgba(10, 12, 16, 0.64)',
  inkLight4: 'rgba(10, 12, 16, 0.28)',
  hairlineLightRule: 'rgba(10, 12, 16, 0.08)',
  hairlineLightPanel: 'rgba(10, 12, 16, 0.12)',
  workingLight: '#4652c9',
  linkLight: '#3b45b8',
  shippedLight: '#12744a',
  dangerLight: '#b8262f',
  warningLight: '#8a4d00',
} as const;

export type PaletteName = keyof typeof PALETTE;
